export const buildFilterQueryString = (selectedFilters, filterKeys) => {
  let url = "?";
  // eslint-disable-next-line guard-for-in
  const params = window.location.search.replace("?", "").split("&");

  const selectedFilterKeys = selectedFilters.map(filter => filter.key);

  const nonFilterParams = params.filter(param => param.includes("=") && param.charAt(param.length - 1) !== "=");
  const nonFilterParamsString = nonFilterParams.length ? `&${nonFilterParams.join("&")}` : "";

  if (filterKeys) {
    url += filterKeys.join("&");
  } else {
    url += selectedFilterKeys.join("&") + nonFilterParamsString;
  }
  return url;
};

const filterGenerator = (selected, filter, param) => {
  const currentFilter = {};
  const selections = filter.selections || filter.subCategories;

  selections.forEach((selection) => {
    if (selection.key === param) {
      currentFilter.key = selection.key;
      currentFilter.displayName = selection.name;
      if (selection.key === "kinds-rings") currentFilter.showIfSelected = "size";
      else if (selection.key === "kinds-necklaces") currentFilter.showIfSelected = "length";
      else currentFilter.showIfSelected = "";
      currentFilter.singleSelection = filter.singleSelection;
      currentFilter.defaultHide = filter.defaultHide;
      selected.push(currentFilter);
    }
  });
};

export const transformKeysToSelectedFilterObjects = (params, filters, sorts) => {
  const selected = [];

  params.forEach((param) => {
    // eslint-disable-next-line prefer-destructuring
    let key = param.split("-")[0];
    filters.forEach((filter) => {
      if (filter.key.includes(key)) {
        if (param.split("-").length <= 2) {
          filterGenerator(selected, filter, param);
        } else {
          key += `-${param.split("-")[1]}`;
          filter.selections.forEach((selection) => {
            if (selection.key.includes(key)) {
              filterGenerator(selected, selection, param);
            }
          });
        }
      }
    });
    if (param.indexOf("sort") === 0) {
      selected.push(sorts.find(sort => sort.key === param));
    }
  });

  return selected;
};

export const storeFilterParamsInCookie = (cookies, filterParams) => {
  if (window.location.pathname.includes("jewelry")) {
    cookies.set("filterParamsJewelry", filterParams, {"path": "/jewelry"});
  } else if (window.location.pathname.includes("shop/clearance")) {
    cookies.set("filterParamsClearance", filterParams, {"path": "/shop/clearance"});
  } else if (window.location.pathname.includes("shop")) {
    cookies.set("filterParamsShop", filterParams, {"path": "/shop"});
  }
};

export const readFilterParamsFromCookie = (cookies) => {
  let filterParamsValue = null;

  if (window.location.pathname.includes("jewelry")) {
    filterParamsValue = cookies.get("filterParamsJewelry");
  } else if (window.location.pathname.includes("shop/clearance")) {
    filterParamsValue = cookies.get("filterParamsClearance");
  } else if (window.location.pathname.includes("shop")) {
    filterParamsValue = cookies.get("filterParamsShop");
  }

  return filterParamsValue || [];
};
